module.exports = __webpack_public_path__ + "static/media/secondary-teacher.f3d11f40.jpg";